<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/183d622/tc-custom/9781683353232.jpg?1695289021921" alt="This image is the cover for the book Home Made Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home Made Christmas
      </h1>
      <p class="bookDescription body article font2">
        <b>Make ahead and make merry with over 100 holiday recipes for family and guests!</b><br/><br/>Author of the Home Made series of cookbooks Yvette van Boven loves the holidays—and she’s never short of ideas for celebrations. In <i>Home Made Christmas</i>, she shows you how to make the season less stressful with her “make ahead” recipes, giving you time to enjoy your company when they arrive. <br/><br/><i>Home Made Christmas</i> includes more than 100 recipes (organized by Prepare Ahead and To Finish It Off) that are all easy to make and delicious. With her step-by-step directions, you’ll know exactly what to do and when—she even provides menu ideas to make all your planning easier. Whether you’re celebrating your first Christmas with the love of your life or cooking for your entire family, this cookbook makes sure you’re fully prepared to entertain your holiday guests with a delicious, satisfying meal.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yvette van Boven, Oof Verschuren
      </h2>
      
      <p class="authorDescription body article">Yvette van Boven is a critically-acclaimed cookbook author, freelance recipe writer, and illustrator. She is also the host of Holland’s popular cooking show Koken Met van Boven.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b26ab64a